module.exports = __webpack_public_path__ + "static/media/search-navs.0735ba82.svg";